document.addEventListener('DOMContentLoaded', () => {
    window.dataLayer = window.dataLayer || [];

    const burgerButtons = [
        document.getElementById('mobileNavCtrl'),
        document.getElementById('mobileNavCtrlDesktop'),
    ];

    const mobMenu = document.getElementById('mobMenu');

    burgerButtons.forEach(btn => {
        if (!btn) return;
        
        btn.addEventListener('click', () => {
            if (!btn.classList.contains('menu-button')) return;
            if (!mobMenu?.classList.contains('open')) return;

            window.dataLayer.push({
                event: 'event',
                eventCategory: 'navigation data',
                eventAction: 'navigation_click',
                eventLabel: 'burger_menue/menue',
            });
            window.dataLayer.push({
                event: 'econdaEvent',
                ecCustomProperties: {
                    Target: ['navigation data', 'navigation_click/burger_menue/menue', 0, 'd'],
                    rqtype: 'hiddenpi',
                },
            });
        });
    });

    const header = document.querySelector('header');
    header?.querySelectorAll<HTMLAnchorElement>('a[data-quicklink-label]').forEach(el => {
        el.addEventListener('click', () => {
            const label = el.dataset.quicklinkLabel ?? '';
            if (!label) return;

            window.dataLayer.push({
                event: 'event',
                eventCategory: 'navigation data',
                eventAction: 'navigation_click',
                eventLabel: `quicklink_${label}`,
            });
            window.dataLayer.push({
                event: 'econdaEvent',
                ecCustomProperties: {
                    Target: ['navigation data', `navigation_click/quicklink/${label}`, 0, 'd'],
                    rqtype: 'hiddenpi',
                },
            });
        });
    });
});
